export enum NcCompareContext {
    Original = "original",
    Leasing = "leasing",
}
